import type { SITE_EVENTS_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-events-card/site-events-card.fr.ts";

export const SITE_EVENTS_CARD_ENGLISH_LOCALE = {
  title: "Events",
  collapseAll: "Collapse all",
  expandAll: "Expand all",
  filterEventCategories: "Filter event categories",
  details: "Details",
  creationDate: "Creation date",
  category: "Category",
  operator: "Operator",
  priority: "Priority",
  status: "Status",
  description: "Description",
  truncatedTitle: "Partial display",
  truncated: "Too much data to display",
} satisfies typeof SITE_EVENTS_CARD_FRENCH_LOCALE;
